<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 2.5L14.6788 3.93462C14.7434 3.97683 14.8196 3.99741 14.8968 3.99368V3.99368L17.5022 3.84843L18.6734 6.16858C18.708 6.23722 18.7636 6.29291 18.8323 6.32749V6.32749L21.1517 7.50335L21.0065 10.1094C21.0028 10.1866 21.0235 10.2628 21.0655 10.3274V10.3274L22.5 12.5023L21.0655 14.677C21.0247 14.7426 21.0013 14.8176 20.9974 14.895V14.895L21.1427 17.501L18.8232 18.6724C18.7546 18.707 18.6989 18.7627 18.6643 18.8313V18.8313L17.4932 21.1515L14.8875 21.0061C14.8106 21.0025 14.7343 21.0231 14.6698 21.0651V21.0651L12.4954 22.4999L10.3212 21.0651C10.2614 21.0274 10.1921 21.007 10.1213 21.0061V21.0061H10.1032L7.49778 21.1515L6.32662 18.8313C6.29205 18.7627 6.23637 18.707 6.16775 18.6724V18.6724L3.84812 17.501L3.99334 14.895C3.99707 14.8178 3.9765 14.7417 3.93447 14.677V14.677L2.5 12.5023L3.93447 10.3229C3.9765 10.2582 3.99707 10.1819 3.99334 10.105V10.105L3.84812 7.49874L6.16775 6.32749C6.23637 6.29291 6.29205 6.23722 6.32662 6.16858V6.16858L7.50222 3.84843L10.1079 3.99368C10.1848 3.99741 10.2611 3.97683 10.3256 3.93462V3.93462L12.5 2.5Z"
				:stroke="color"
				stroke-width="1.5"
			/>
			<path
				d="M12.4998 6.53613C15.7908 6.53613 18.4643 9.2149 18.4643 12.5022C18.4643 15.7893 15.7862 18.468 12.4998 18.468C9.21331 18.468 6.53516 15.7893 6.53516 12.5022C6.53516 9.2149 9.20888 6.53613 12.4998 6.53613Z"
				:stroke="color"
				stroke-width="1.5"
			/>
			<path
				d="M15.5034 11.052C15.3655 10.9065 15.1359 10.9003 14.9905 11.0383V11.0383L11.6497 14.1892L10.0155 12.5093C9.87458 12.3688 9.64691 12.3679 9.50506 12.5073C9.36303 12.6467 9.36001 12.8746 9.49796 13.0179V13.0179L11.3818 14.952C11.4493 15.0226 11.5429 15.0619 11.6405 15.0611C11.7337 15.0623 11.8236 15.0263 11.8901 14.961V14.961L15.4898 11.565C15.6352 11.4271 15.6414 11.1974 15.5034 11.052Z"
				:stroke="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgCertificat',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
